import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/Badge";
import { CompanyLogo } from "@/components/section/journey/CompanyLogo";
import { cn } from "@/utils/helpers";
import { ExperienceEntry } from "@/utils/interfaces";
type ExperienceHeaderSize = "sm" | "lg";
type ExperienceHeaderTitle = "h2" | "h3";
interface ExperienceHeaderProps {
  experience: ExperienceEntry;
  size?: ExperienceHeaderSize;
  titleAs?: ExperienceHeaderTitle;
  className?: string;
}
export const ExperienceHeader = t0 => {
  const $ = _c(40);
  const {
    experience,
    size: t1,
    titleAs: t2,
    className
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const titleAs = t2 === undefined ? "h2" : t2;
  const {
    title,
    company,
    location,
    type,
    startDate,
    endDate
  } = experience;
  const Heading = titleAs;
  let t3;
  if ($[0] !== className) {
    t3 = cn("flex items-start justify-between gap-4", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== company || $[3] !== size) {
    t4 = <CompanyLogo company={company} size={size} />;
    $[2] = company;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = size === "lg" ? "heading-3" : "heading-4";
  let t6;
  if ($[5] !== t5) {
    t6 = cn(t5, "mb-1");
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== Heading || $[8] !== t6 || $[9] !== title) {
    t7 = <Heading className={t6}>{title}</Heading>;
    $[7] = Heading;
    $[8] = t6;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = size === "lg" ? "body-base" : "body-small";
  let t9;
  if ($[11] !== company || $[12] !== t8) {
    t9 = <p className={t8}>{company}</p>;
    $[11] = company;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== location || $[15] !== size) {
    t10 = location && <p className={cn(size === "lg" ? "body-base" : "body-small", "mt-0.5")}>{location}</p>;
    $[14] = location;
    $[15] = size;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7 || $[19] !== t9) {
    t11 = <div>{t7}{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t4) {
    t12 = <div className="flex flex-col sm:flex-row sm:items-start gap-3">{t4}{t11}</div>;
    $[21] = t11;
    $[22] = t4;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== type) {
    t13 = <Badge>{type}</Badge>;
    $[24] = type;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== startDate) {
    t14 = <p>{startDate}</p>;
    $[26] = startDate;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== endDate) {
    t15 = <span className="pl-0.5">– {endDate}</span>;
    $[28] = endDate;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t14 || $[31] !== t15) {
    t16 = <time className="body-small text-right">{t14}{t15}</time>;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t13 || $[34] !== t16) {
    t17 = <div className="flex flex-col items-end gap-1 shrink-0">{t13}{t16}</div>;
    $[33] = t13;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t12 || $[37] !== t17 || $[38] !== t3) {
    t18 = <header className={t3}>{t12}{t17}</header>;
    $[36] = t12;
    $[37] = t17;
    $[38] = t3;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};